import Header from "./components/Header";
import Hero from "./components/Hero";
import RepairServices from "./components/RepairServices";
import RepairItems from "./components/RepairItems";
import RepairCases from "./components/RepairCases";
import RepairProcess from "./components/RepairProcess";
import RepairPricing from "./components/RepairPricing";
import Reviews from "./components/Reviews";
import Faq from "./components/Faq";
import Location from "./components/Location";
import InquiryForm from "./components/InquiryForm";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import { useReveal } from "@/hooks/useReveal";

export default function Home() {
  useReveal();

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Header />
      <main>
        <Hero />
        <RepairServices />
        <RepairItems />
        <RepairCases />
        <RepairProcess />
        <RepairPricing />
        <Reviews />
        <Faq />
        <Location />
        <InquiryForm />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}